import React, { FC } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../components/icon/Icon';
import AteneaForDark from '../../../assets/AteneaForDark.png';

interface IBrandProps {
	asideStatus: boolean;
	setAsideStatus(...args: unknown[]): unknown;
}
const CisBrand: FC<IBrandProps> = ({ asideStatus, setAsideStatus }) => {
	return (
		<div className='brand'>
			<div className='brand-logo'>
				<h1 className='brand-title '>
					<img
						src={AteneaForDark}
						className='ms-2'
						alt='ateneaIcon'
						style={{
							// filter: 'grayscale(3) brightness(2.5) contrast(10)',
							height: '30px',
						}}
					/>
				</h1>
			</div>
			<button
				type='button'
				className='btn brand-aside-toggle'
				aria-label='Toggle Aside'
				onClick={() => setAsideStatus(!asideStatus)}>
				<Icon icon='FirstPage' className='brand-aside-toggle-close' />
				<Icon icon='LastPage' className='brand-aside-toggle-open' />
			</button>
		</div>
	);
};
CisBrand.propTypes = {
	asideStatus: PropTypes.bool.isRequired,
	setAsideStatus: PropTypes.func.isRequired,
};

export default CisBrand;
